import { marker } from '@jsverse/transloco-keys-manager/marker';
import { EncounterStatus } from '@pixacare/domain';

type EncounterConfig = {
  appearance: string;
  label: string;
};

export const encounterStatusConfig: { [encounter in EncounterStatus]: EncounterConfig } = {
  [EncounterStatus.FINISHED]: {
    appearance: 'warning',
    label: marker('Terminé'),
  },
  [EncounterStatus.IN_PROGRESS]: {
    appearance: 'positive',
    label: marker('En cours'),
  },
  [EncounterStatus.PLANNED]: {
    appearance: 'info',
    label: marker('Planifié'),
  },
};

export const unknownEncouterStatusConfig: EncounterConfig = {
  appearance: 'negative',
  label: marker('Statut inconnu'),
};
